import React, {
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import {
    ActionButtons,
    ActionButtonTypes,
    buildActionButton,
    JoinedColumnType
} from "../../../components/Grid/Columns";
import {useNavigate} from "react-router";
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {FilterBar} from "../../../components/Grid/FilterBar";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";
import UserRepository from "../../../repositories/UserRepository";

const UserListView = () => {

	const navigate = useNavigate();
	const repository = new UserRepository();
	const {t}  = useTranslation();

	const sortOptions = [
      {
        value: 'Id|desc',
        label: t('Newest first')
      },
      {
        value: 'Id|asc',
        label: t('Oldest first')
      }
    ];

    const handleEditItemClick = (event) => {
	    navigate("/app/users/" + event.Id);
    }

	const {items, totalCount, itemsOnPage, onEditHandler, onPage, isSearching, onFilterChangedHandler, onSortChangedHandler, filter, sort, updateGrid } = useGrid(repository, { onEdit: handleEditItemClick, defaultSort: sortOptions[0].value });

	const columns = [
        { field: 'Name', headerName: t('Name'), width: 200, sortable: false  },
        { field: 'Roles', headerName: t('Roles'), ... JoinedColumnType, width: 250 },
        { field: 'GroupNames', headerName: t('Assigned zone groups'), ... JoinedColumnType, width: 300 },
        { field: 'ZoneNames', headerName: t('Assigned zones'), ... JoinedColumnType, width: 300 },
        {
          headerName: t('Actions'),
          field: 'edit',
          ...ActionButtons([buildActionButton(ActionButtonTypes.EDIT, t("Edit"), onEditHandler)])
        }
    ];

	return (
	    <GridSkeleton title={t("USERS")}
                      isSearching={isSearching}
                      header={(<Header onRefresh={updateGrid} />)}
                      filter={(<FilterBar showQuerySearch={true} sortOptions={sortOptions} onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort} />)}
                      grid={(<DataGrid
                                   disableMultipleSelection={true}
                                   disableColumnFilter
                                   rows={items()}
                                   rowCount={totalCount()}
                                   columns={columns}
                                   pageSize={itemsOnPage}
                                   paginationMode="server"
                                   sortingMode="server"
                                   disableColumnSelector={true}
                                   disableSelectionOnClick={true}
                                   disableColumnMenu={true}
                                   onPageChange={onPage}
                                   rowsPerPageOptions={[itemsOnPage]}
                                   hideFooterSelectedRowCount={true}
                         />)}
        />

	);
};

export default UserListView;